module.exports = __webpack_public_path__ + "static/media/Future Innovations blog img.939648f5.webp";